import { useContext } from "react";

import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import TableContext from "context/table/tableContext";
import { useMediaQueries } from "shared/hooks/useMediaQueries";
import {
    filterDropdownCustomMargin,
    generalFiltersBlockStyle
} from "shared/styles";
import { FILTER_NAMES } from "shared/types/enums";

import FilterButton from "../components/FilterButton";
import FilterMenu from "../components/FilterMenu";
import FilterDropdown from "../FilterDropdown";
import { useFilters } from "../hooks/useFilters";

const DeviceGroupDetailFilters = () => {
    const { hasNoPermissionToRead, innerTableQueryParams } =
        useContext(TableContext);

    const { t } = useTranslation();
    const { toLg, fromLg } = useMediaQueries();
    const { anchorEl, handleOpenMenu, handleCloseMenu } = useFilters();

    const additionalParams = `${[FILTER_NAMES.GroupId]}=${innerTableQueryParams[FILTER_NAMES.GroupId]}`;

    return (
        <div css={css(generalFiltersBlockStyle)}>
            {fromLg && (
                <FilterDropdown
                    filter={FILTER_NAMES.TaskStatus}
                    placeholder={t(`Filter##${FILTER_NAMES.TaskStatus}`)}
                    additionalParams={additionalParams}
                    disabled={hasNoPermissionToRead}
                    css={css([filterDropdownCustomMargin])}
                />
            )}

            <FilterButton
                onOpen={handleOpenMenu}
                isDisabled={hasNoPermissionToRead}
            >
                {fromLg ? t("Button##more filters") : t("Button##filters")}
            </FilterButton>

            <FilterMenu
                isOpen={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={handleCloseMenu}
            >
                <div
                    css={css({
                        "& > div + div": {
                            marginTop: "12px"
                        }
                    })}
                >
                    {toLg && (
                        <FilterDropdown
                            filter={FILTER_NAMES.TaskStatus}
                            placeholder={t(
                                `Filter##${FILTER_NAMES.TaskStatus}`
                            )}
                            additionalParams={additionalParams}
                            css={css([filterDropdownCustomMargin])}
                        />
                    )}

                    <FilterDropdown
                        filter={FILTER_NAMES.Type}
                        placeholder={t("Filter##task type")}
                        additionalParams={additionalParams}
                    />
                </div>
            </FilterMenu>
        </div>
    );
};

export { DeviceGroupDetailFilters };
